import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { nullableRequired, optionSchema } from '@/js/libs/form';

export const useSchema = () => {
  const [t] = useTranslation(['backend', 'messages']);

  return z.object({
    namespace: nullableRequired(optionSchema(z.string()), t('messages:FIELD_IS_REQUIRED')),
    key: z.string().min(1, t('messages:FIELD_IS_REQUIRED')),
    valueEn: z.string().min(1, t('messages:FIELD_IS_REQUIRED')),
    valueDe: z.string().min(1, t('messages:FIELD_IS_REQUIRED')),
    valueFr: z.string().min(1, t('messages:FIELD_IS_REQUIRED')),
    valueIt: z.string().min(1, t('messages:FIELD_IS_REQUIRED')),
    valueDeAt: z.string(),
    valueDeDe: z.string(),
  });
};

type Schema = ReturnType<typeof useSchema>;
export type FormValues = z.input<Schema>;
export type SubmitValues = z.output<Schema>;
